import React from "react";
// import {Link} from 'react-router-dom';
import Constant from "../../Constant.js";
//import OverlayLoader from 'react-loading-indicator-overlay/lib/OverlayLoader'
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
import LiveStream from "../modals/LiveStream.js";
import Quizreport from "../modals/Quizreport";
import ActivityModal from "../modals/ActivityModal";
import Query from "../modals/Query";
import Fullscreen from "react-full-screen";

// import React from "react";
// import Constant from "../Constant.js";
// import LiveStream from "./modals/LiveStream";

class ViewVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      quizs: [],
      counter: 0,
      video_details: [],
      video_id: "",
      session: "",
      openQuizModal: false,
      openreport: false,
      openActivityModel: false,
      openquery: false,
      isFull: false,
      course_details:{
        course_id:""
      },

    };
  }
  componentWillMount() {
    // this.getVideo_Unit();
    // this.getCourseList();
    // this.createquizprogress();
  }
  onOpenQuizModal = () => {
    this.setState({ openQuizModal: true });
  };
  onCloseQuizModal = () => {
    var vid = document.getElementById("myVideo");
    vid.currentTime = vid.currentTime + 1;
    vid.play();
    this.setState({ openQuizModal: false });
  };

  componentDidUpdate(prevProps, prevState) {
    var that = this;
    var vid = document.getElementById("myVideo");
    vid.ontimeupdate = function() {
      vid.onseeking = function() {
        let seek = parseInt(vid.currentTime);
        console.log(seek);
        var seek_arr = [];
        for (let i = 0; i < that.state.video_details.quiz_list.length; i++) {
          if (
            parseInt(seek) >=
            parseInt(that.state.video_details.quiz_list[i].pause_at)
          ) {
            let obj = that.state.video_details.quiz_list[i];
            seek_arr.push(obj);
          }
        }
        console.log("seek Arr :: " + seek_arr);
      };
      for (let i = 0; i < that.state.video_details.quiz_list.length; i++) {
        if (
          parseInt(vid.currentTime) ==
          parseInt(that.state.video_details.quiz_list[i].pause_at)
        ) {
          vid.pause();
          if (vid.paused == true) {
            that.onOpenQuizModal();
            that.setState({
              quiz_id: that.state.video_details.quiz_unit_id,
              pause_at: that.state.video_details.quiz_list[i].pause_at
            });
          } else {
            alert("not open");
          }
        }
      }
    };
  }
  getCourseList = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    }
    data.append("list_type", Constant.default_course_cat_list_type());
    data.append("language_id", Constant.language_id());
    //  data.append("category_id",id);
    if (that.props.location.state) {
      data.append("category_id", that.props.location.state.category_id);
    }
    fetch(Constant.getAPI() + "/coursecataloglist", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          for (var i = 0; i < json.data.length; i++) {
            if (
              that.props.match.params.course_id === json.data[i].main_course_id
            ) {
              var obj = {};
              obj.course_id = json.data[i].course_id;
              obj.course_name = json.data[i].course_name;
              obj.course_status = json.data[i].course_status;
              obj.category_id = json.data[i].main_category_id;
              obj.category_name = json.data[i].category_name;
              obj.course_price = json.data[i].course_price;
              obj.course_free_paid_status =
                json.data[i].course_free_paid_status;
              obj.course_image = json.data[i].course_image;
              obj.cover_image_url = json.data[i].cover_image_url;
              obj.catalog_display = json.data[i].catalog_display;
              obj.auto_enroll = json.data[i].auto_enroll;
              obj.course_description = json.data[i].course_description;
              obj.course_code = json.data[i].course_code;
              obj.course_duration = json.data[i].course_duration;
              obj.time_per_day = json.data[i].time_per_day;
              obj.no_of_lesson = json.data[i].no_of_lesson;
              obj.language_id = json.data[i].language_id;
              obj.created_by_details = json.data[i].created_by_details;
              obj.user_subscribed_flag = json.data[i].user_subscribed_flag;
              that.setState({
                course_details: obj,
                isLoading: false,
                user_subscribed_flag: json.data[i].user_subscribed_flag
              });
            }
          }
        } else {
          that.setState({ isLoading: false });
          console.log(json.error);
        }
      });
  };
  getVideo_Unit = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
      data.append("domain_code", Constant.domain_code());
    }
    data.append("main_course_unit_id", that.props.match.params.unit_id);
    data.append("main_course_id", that.props.match.params.course_id);
    data.append("language_id", Constant.language_id());
    fetch(Constant.getAPI() + "/unitdetails", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          that.setState({ video_details: json.data, isLoading: false });
          for (let i = 0; i < that.state.video_details.quiz_list.length; i++) {
            that.setState({ quizs: that.state.video_details.quiz_list });
          }
          console.log(that.state.quizs);
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  savequizanswer = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("domain_code", localStorage.getItem("sk_dom_sh_code"));
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
      data.append("domain_code", Constant.domain_code());
    }
    data.append("main_course_unit_id", that.props.match.params.unit_id);
    data.append("language_id", Constant.language_id());
    data.append("session", that.state.session);
    data.append("quiz_answers", localStorage.getItem("quiz"));
    fetch(Constant.getAPI() + "/savequizanswer", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log("savequizanswer");
          console.log(json.data);
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  videoend = () => {
    if (localStorage.getItem("sk_is_login") === "true") {
      if (localStorage.getItem("quiz")) {
        this.savequizanswer();
        this.onOpenModal_report();
      } else {
        window.location.href =
          "#/course_desc/" + this.props.match.params.course_id;
      }
    } else {
      window.location.href =
        "#/course_desc/" + this.props.match.params.course_id;
    }
  };
  onOpenModal_report = () => {
    this.setState({ openreport: true });
  };
  onCloseModal_report = () => {
    this.setState({ openreport: false });
    this.onOpenModal_activity();
  };
  onOpenModal_activity = () => {
    this.setState({ openActivityModel: true });
  };
  onCloseModal_activity = () => {
    this.onOpenModal_query();
    this.setState({ openActivityModel: false });
  };
  onOpenModal_query = () => {
    this.setState({ openquery: true });
  };
  onCloseModal_query = () => {
    window.location.href = "#/course_desc/" + this.props.match.params.course_id;
    this.setState({ openquery: false });
  };
  createquizprogress = () => {
    var that = this;
    var data = new FormData();
    if (localStorage.getItem("sk_is_login") === "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    } else if (localStorage.getItem("sk_guestuser") == "true") {
      data.append("usermaster_id", localStorage.getItem("sk_uid"));
    }
    data.append("language_id", Constant.language_id());
    data.append("main_course_unit_id", that.props.match.params.unit_id);
    data.append("coursemaster_id", that.props.match.params.course_id);
    fetch(Constant.getAPI() + "/createquizprogress", {
      method: "post",
      body: data
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.error === "SFD") {
          console.log(json.data);
          that.setState({ session: json.data.session });
        } else {
          that.setState({ isLoading: false });
          console.log("Error Found  " + json.error);
        }
      });
  };
  onFullScreen = () => {
    console.log(this.state.isFull);
    this.setState({ isFull: !this.state.isFull });
  };

  render() {
    var opts = {
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: this.state.autoplay,
        modestbranding: 1,
        rel: 0,
        showsearch: 0,
        mode: "opaque",
        autohide: 1,
        showinfo: 0,
        wmode: "transparent"
      }
    };
    return (
      <div>
        <div className="col-md-12 fleft margin text-uppercase">
          {/* <ul className="breadcrumb">
            <li>
              <a className="link-color-dark" href="#/">
                Home
              </a>
            </li>
            <li>
              <a className="link-color-dark" href="#/mostview">
                All Courses
              </a>
            </li>
            <li>
              <a
                className="link-color-dark"
                href={`#/course_desc/${this.state.course_details.course_id}`}
              >
                {this.state.course_details.course_name}
              </a>
            </li>
            <li>
              <span className="text-primary">
                {this.state.video_details.unit_name}
              </span>
            </li>
          </ul> */}
        </div>
        <Fullscreen
          enabled={this.state.isFull}
          onChange={isFull => this.setState({ isFull })}
        >
          <div className="container right-panel media-player shadow my-3 p-0">
            {/*<OverlayLoader color={'#a51822'} loader="ScaleLoader" active={this.state.isLoading} opacity=".5">*/}
            <div className="container main-container-quiz mx-auto">
              <section>
                <div className="container new-quiz mx-auto py-3">
                  <div className="row mx-auto">
                    <div className="col-md-8 mx-auto  post_page_uploads">
                      <div className="author_details post_details row m0">
                        <div className="embed-responsive embed-responsive-16by9">
                          <video
                            ref="vidRef"
                            id="myVideo"
                            className="simple_video shadow-sm"
                            onEnded={this.videoend}
                            controls
                            autoPlay="true"
                            src={
                              this.state.video_details.media_path === ""
                                ? "./theme/video/office.mp4"
                                : this.state.video_details.media_path
                            }
                            type="video/mp4"
                          >
                            Your browser does not support HTML5 video.
                          </video>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div className="container text-center heading-quiz new-quiz mx-auto">
              <div className="row mx-auto">
                <div className="col text-left">
                  <h3
                    className="line-height-1 font-secondary text-4"
                    style={{ textTransform: "capitalize" }}
                  >
                    {this.state.video_details.unit_name}
                  </h3>
                </div>
                <div className="col-1 compress-btn d-flex justify-content-center">
                  <i class="fas fa-compress" onClick={this.onFullScreen}></i>
                </div>
              </div>
            </div>

            <LiveStream
              quizs={this.state.quizs}
              pause_at={this.state.pause_at}
              session={this.state.session}
              main_course_unit_id={this.props.match.params.unit_id}
              coursemaster_id={this.props.match.params.course_id}
              open={this.state.openQuizModal}
              close={this.onCloseQuizModal}
            />
          </div>
        </Fullscreen>
      </div>
    );
  }
}
export default ViewVideo;
